import ICONS from "../../../../../assets/Icons";
import globalText from "../../../../../utils/globalText";
import { globalTextFormat } from "../../../../../utils/globalTextFormat";
import AssignLabels from "../../../../_utils/AccountCreationComponents/AssignLabels";
import CommonLayout from "../../../../_utils/CommonLayout";
import AdditionalDetailsPreviewMapper from "../../../../_utils/TransactionCommonComponents/AdditionalDetailsPreviewMapper";
import Amount from "../../../../_utils/TransactionCommonComponents/Amount";
import CommonDestinationAccount from "../../../../_utils/TransactionCommonComponents/CommonDestinationAccount";
import ConfidentialCard from "../../../../_utils/TransactionCommonComponents/ConfidentialCard";
import NameFieldCard from "../../../../_utils/TransactionCommonComponents/NameFieldCard";
import PaymentMethodSelector from "../../../../_utils/TransactionCommonComponents/PaymentMethodSelector";
import CommonSourceAccount from "../../../../_utils/TransactionCommonComponents/CommonSourceAccount";
import TransactionOccurrenceDetails from "../../../../_utils/TransactionCommonComponents/TransactionOccurrenceDetails";

const formatPreviewDate = (date) => {
  const parsed = new Date(date || new Date());
  const day = parsed.toLocaleDateString("en-GB", { day: "2-digit" });
  const month = parsed.toLocaleDateString("en-GB", { month: "short" });
  const year = parsed.toLocaleDateString("en-GB", { year: "numeric" });
  return `${day} ${month}, ${year}`;
};

const ScheduleInternalTransactionStepConfirm = ({
  txnPayLoad,
  setTxnPayLoad,
  isConfidential,
  availableSlots,
  previewImages,
  allLabels,
  uploadedFiles,
}) => {
  return (
    <div className="w-width-full Qlg:px-padding-base px-padding-md py-padding-md max-w-tab-width-normal mx-auto">
      <CommonLayout>
        <CommonSourceAccount
          type="source"
          txnPayLoad={txnPayLoad}
          setTxnPayLoad={setTxnPayLoad}
          page="confirm"
        />

        <CommonDestinationAccount
          transactionPayload={txnPayLoad}
          setTransactionPayload={setTxnPayLoad}
          isReadOnly
          showsBalance={false}
        />
        <div className="w-width-full flex flex-col gap-gap-md">
          <Amount isPreview={true} txnPayLoad={txnPayLoad} />

          <PaymentMethodSelector
            previewMode={true}
            showUnassignLink={false}
            selectedMethod={txnPayLoad?.settleType}
          />
        </div>

        <div className="w-width-full flex flex-col gap-gap-md">
          <NameFieldCard
            title={globalTextFormat(globalText?.SCHEDULE_NAME, [0, 1])}
            value={txnPayLoad?.scheduled_name}
            previewMode={true}
          />

          <ConfidentialCard
            icon={ICONS?.CONFIDENTIAL_TRANSACTION}
            title={globalText.CREATE_AS_CONFIDENTIAL}
            note={globalText.CONFIDENTIAL_SCHEDULE_TRANSACTION_NOTE}
            toggleState={isConfidential}
            isPreview={true}
          />
        </div>

        <TransactionOccurrenceDetails
          txnPayLoad={txnPayLoad}
          formatDate={formatPreviewDate}
          SlotMappingData={availableSlots}
          previewMode={true}
        />

        <AdditionalDetailsPreviewMapper
          mappingData={txnPayLoad?.mergeCategory}
          previewImages={previewImages}
          uploadedFiles={uploadedFiles}
        />

        <AssignLabels previewMode={true} labels={allLabels} isOptional={true} />
      </CommonLayout>
    </div>
  );
};

export default ScheduleInternalTransactionStepConfirm;
